import React from 'react'

import Image from "../../assets/images/logo-tmhcc.svg";

import "./Loading.css";

const Loading = () => {
    return (
        <div className="loading-container">
            <div className="loading-image">
                <img src={Image} alt="Logo" />
            </div>
            <h3 className='loading-icon'>Loading...</h3>
        </div>
    )
}

export default Loading